import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { range } from '../../utils/utils.js';
import styles from './Ellipsis.module.scss.js';

const THEMES = {
    default: '',
    dark: 'darkTheme',
};
const Ellipsis = ({ amount = 4, identifier = 'key', }) => {
    return (jsx("div", { className: styles.ellipsis, children: range(amount).map((idx) => (jsx("div", { className: styles.ellipse }, `${identifier}--${idx}`))) }));
};
const EllipsisContainer = ({ children, theme = 'default', }) => {
    return (jsx("div", { className: classNames(styles.ellipsisContainer, styles?.[THEMES?.[theme]] || undefined), children: children }));
};

export { EllipsisContainer, Ellipsis as default };
//# sourceMappingURL=Ellipsis.js.map
